export const STORAGE_VISIT_DATA_PATH = 'ke-portal-visit-data'
